import { axios } from '@ben/api/axios';

export const getStringListDropdownOptions = (
  modelName: string
): (() => Promise<string[]>) => {
  return async (): Promise<string[]> => {
    const response = await axios.get<string[]>(`${modelName}/`);
    return response?.data;
  };
};
